import React from "react";
import _ from "lodash";
import ReactHtmlParser from "react-html-parser";

import { formatDate } from "../../../../utils/dates";
import styles from "./Note.scss";

class Note extends React.Component {
  render() {
    const { note } = this.props;

    const isFromCurrentUser =
      _.get(note, "from.email") === localStorage.getItem("userEmail");

    const footerFromText = isFromCurrentUser
      ? "You"
      : _.get(note, "from")
      ? `${note.from.first_name} ${note.from.last_name}`
      : "System";

    const footerText = `${footerFromText} on ${formatDate(
      note.created_at,
      "MMM DD, YYYY, h:mm a"
    )}`;

    return (
      <div className={styles.noteContainer}>
        <div className={styles.note}>
          <div className={styles.noteText}>{ReactHtmlParser(note.note)}</div>
        </div>

        <div className={styles.noteFooter}>{footerText}</div>
      </div>
    );
  }
}

export default Note;



// WEBPACK FOOTER //
// ./src/routes/common/adminNotes/Note/Note.js